import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./components/AuthContext/AuthContext";
import { SelectedCollectionsProvider } from "./components/SelectedCollectionsContext/SelectedCollectionsContext";
import router from "./router";
import "./index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SelectedCollectionsProvider>
        <RouterProvider router={router} />
      </SelectedCollectionsProvider>
    </AuthProvider>
  </React.StrictMode>
);
